import { useState } from 'react';
import { logEvent, analytics } from '../firebase.js';
import { isNativeApp } from '../services/platform-service.js';
import { storeUrlForDevice, mobileOS } from '../services/app-links.js';
import { useLocale } from '../hooks/useLocale.jsx';

// 공유 링크·프로필로 웹에 들어온 사람에게 앱 설치를 권하는 줄.
//
// 왜 막지 않고 권하기만 하나: 링크를 받고 들어온 사람은 아직 이 앱이 뭔지
// 모른다. 여기서 설치를 강제하면 대부분 그냥 떠난다. 웹에서 결과를 보고
// 마음이 생긴 다음에 설치가 자연스럽다.
//
// iOS Safari 는 index.html 의 apple-itunes-app 메타로 OS 가 직접 배너를
// 띄워 준다 — 그쪽이 더 신뢰도 높으니 이 컴포넌트는 그 아래에 겹쳐 뜨지
// 않도록 안드로이드만 맡는다. (iOS 에서도 메타 배너를 한 번 닫으면 다시
// 안 나오지만, 그건 사용자가 닫은 것이므로 우리가 또 띄우지 않는다.)
const DISMISS_KEY = 'voda_app_banner_dismissed';

export function GetTheAppBanner({ surface }) {
  const { t } = useLocale();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });

  // 네이티브 앱 안에서는 당연히 숨긴다. 데스크톱도 숨긴다 — 스토어로 보내도
  // 설치할 기기가 아니다.
  if (isNativeApp() || dismissed) return null;
  if (mobileOS() !== 'android') return null;
  const url = storeUrlForDevice();
  if (!url) return null;

  const close = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* 무시 */ }
    setDismissed(true);
    logEvent(analytics, 'app_banner_dismissed', { surface });
  };

  return (
    <div className="app-banner" role="complementary">
      <img className="app-banner-icon" src="/icons/icon-192.webp" alt="" />
      <div className="app-banner-text">
        <strong>{t('getAppTitle')}</strong>
        <span>{t('getAppDesc')}</span>
      </div>
      <a
        className="app-banner-cta"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => logEvent(analytics, 'app_banner_clicked', { surface })}
      >
        {t('getAppCta')}
      </a>
      <button className="app-banner-close" onClick={close} aria-label={t('close')}>
        <i className="material-symbols-rounded">close</i>
      </button>
    </div>
  );
}
